// Pure formatters for the optimal-slots widget. Kept separate so they can
// be unit-tested without rendering React. The §6.3.3 rule "show both
// relative score AND sample size" means we render the slot's score with
// the n-of-samples explicitly attached — never a fake confidence percent.

const DAY_LABELS = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun",
] as const;

/** Map ISO dayOfWeek (0..6) to short label. */
export function slotDayLabel(dayOfWeek: number): string {
  if (dayOfWeek < 0 || dayOfWeek > 6 || !Number.isInteger(dayOfWeek)) {
    return "?";
  }
  return DAY_LABELS[dayOfWeek] ?? "?";
}

/** "Mon 09:00" — header for one slot row. UTC; the page strings clarify. */
export function slotHeader(dayOfWeek: number, hour: number): string {
  return `${slotDayLabel(dayOfWeek)} ${hour.toString().padStart(2, "0")}:00`;
}

/**
 * "12 admin posts" / "1 admin post" — sample-size descriptor. Per §6.3.3
 * we always show this alongside the relative score so the owner can judge
 * the recommendation's reliability themselves.
 */
export function slotSampleLabel(sampleSize: number): string {
  if (sampleSize === 1) return "1 admin post";
  return `${sampleSize} admin posts`;
}
